(function() { module.exports = window["Next"]["Tree"]; }());